import { resources } from "@constants/hardcoded-strings";
import { FormattedRpServiceConfiguration, FormattedRpServiceConfigurationServiceOffering } from "@idw-types/data/rp-service-configuration";
import { affectsTrustScore } from "@utils/scores/trust-score-util";
import { useMemo } from "react";
import { ServiceOfferingWeightsControl } from "./service-offering-weights-control/service-offering-weights-control";
import styles from './service-offering-weights-container.less';
import { TrustScoreErrors } from "@idw-types/common/validation/verification-service-details-validation-errors";

type ServiceOfferingWeightsContainerProps = {
    isDisabled: boolean;
    validationErrors: TrustScoreErrors;
    rpServiceConfigurationState: FormattedRpServiceConfiguration;
    trustScoreServiceOfferingIDs: Array<string>;
    setRpServiceConfigurationState: (
        state: FormattedRpServiceConfiguration
    ) => void;
}

export const ServiceOfferingWeightsContainer = (props: ServiceOfferingWeightsContainerProps) => {
    const { isDisabled,
        validationErrors,
        rpServiceConfigurationState,
        trustScoreServiceOfferingIDs,
        setRpServiceConfigurationState
    } = props;
   

    const trustScoreServiceOfferings = useMemo(() => {
        return affectsTrustScore(rpServiceConfigurationState.serviceOfferings, trustScoreServiceOfferingIDs);
    }, [rpServiceConfigurationState.serviceOfferings]);

    const setServiceOfferingsState = (serviceOffering: FormattedRpServiceConfigurationServiceOffering) => {
        const newServiceOfferings = rpServiceConfigurationState.serviceOfferings.map(so => {
            if (so.uuid === serviceOffering.uuid) {
                return {
                    ...so, weight: serviceOffering.weight
                }
            }

            return so;
        });

        setRpServiceConfigurationState({
            ...rpServiceConfigurationState,
            serviceOfferings: newServiceOfferings
        });
    }

    return <div>
        <h4 className={styles.serviceOfferingWeightsTitle}>{resources.pages.verificationServiceDetails.tabs.scores
            .subTabs.trustScore.sections.serviceOfferingWeights.title}</h4>


        <div>
            {!isDisabled && <p>{resources.pages.verificationServiceDetails.tabs.scores
                .subTabs.trustScore.sections.serviceOfferingWeights.instruction}</p>}
            {isDisabled && <p>Weight assigned to each attribute provider.</p>}
        </div>

       

        <div>
            {validationErrors.noTrustScoreComponentEnabledError}
            {
                trustScoreServiceOfferings.map((so, index) =>
                    <div key={`${index}-${so.weight}`}>
                        <ServiceOfferingWeightsControl id={`${index}`} isDisabled={isDisabled} serviceOffering={so} setServiceOfferingState={setServiceOfferingsState} />
                    </div>

                )
            }
        </div>


    </div >;
}